import React, { useState } from 'react';
import api, { setAuthToken } from '../services/api';

const AdminLogin = ({ onLoginSuccess }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      // Authentification locale de l'administrateur (routes/admin.py).
      // L'API attend l'email admin@comptaai.com + ADMIN_PASSWORD.
      const login = await api.post('/admin/login', {
        email: email.trim(),
        password: password
      });

      const token = login?.data?.access_token;
      if (!login || !login.success || !token) {
        setError(login?.error || 'Identifiants administrateur incorrects');
        return;
      }

      setAuthToken(token);

      // Vérifier que le token est bien un token administrateur
      const response = await api.get('/auth/me');

      if (response && response.success && response.role === 'admin') {
        onLoginSuccess();
      } else {
        setError('Accès refusé. Vous n\'êtes pas administrateur.');
      }
    } catch (err) {
      console.error('Erreur connexion:', err);
      setError(err.message || 'Identifiants incorrects');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#F5F4ED', fontFamily: 'Inter, system-ui, sans-serif'}}>
      <div style={{background: 'white', padding: '40px', borderRadius: '16px', boxShadow: '0 4px 12px rgba(0,0,0,0.1)', width: '100%', maxWidth: '400px'}}>
        {/* Logo */}
        <div style={{textAlign: 'center', marginBottom: '32px'}}>
          <div style={{width: '60px', height: '60px', borderRadius: '12px', background: '#1D9E75', color: 'white', fontSize: '30px', fontWeight: '500', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px'}}>
            C
          </div>
          <h1 style={{fontSize: '24px', fontWeight: '600', color: '#2D2D2D', marginBottom: '8px'}}>ComptaAI Admin</h1>
          <p style={{fontSize: '14px', color: '#73726C'}}>Espace administrateur</p>
        </div>

        {/* Formulaire */}
        <form onSubmit={handleSubmit}>
          <div style={{marginBottom: '20px'}}>
            <label style={{display: 'block', fontSize: '13px', fontWeight: '500', color: '#2D2D2D', marginBottom: '8px'}}>
              Email administrateur
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="admin@comptaai.com"
              required
              style={{width: '100%', padding: '12px', border: '1px solid #E8E7E3', borderRadius: '8px', fontSize: '14px', outline: 'none', transition: 'border-color 0.2s'}}
              onFocus={(e) => e.target.style.borderColor = '#1D9E75'}
              onBlur={(e) => e.target.style.borderColor = '#E8E7E3'}
            />
          </div>

          <div style={{marginBottom: '24px'}}>
            <label style={{display: 'block', fontSize: '13px', fontWeight: '500', color: '#2D2D2D', marginBottom: '8px'}}>
              Mot de passe
            </label>
            <div style={{position: 'relative'}}>
              <input
                type={showPassword ? 'text' : 'password'}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                required
                style={{width: '100%', padding: '12px', paddingRight: '40px', border: '1px solid #E8E7E3', borderRadius: '8px', fontSize: '14px', outline: 'none', transition: 'border-color 0.2s'}}
                onFocus={(e) => e.target.style.borderColor = '#1D9E75'}
                onBlur={(e) => e.target.style.borderColor = '#E8E7E3'}
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                style={{position: 'absolute', right: '12px', top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', fontSize: '16px', padding: '0', display: 'flex', alignItems: 'center', justifyContent: 'center'}}
              >
                {showPassword ? '🙈' : '👁️'}
              </button>
            </div>
          </div>

          {error && (
            <div style={{background: '#FCEBEB', border: '1px solid #F5B5B5', borderRadius: '8px', padding: '12px', marginBottom: '20px', fontSize: '13px', color: '#A32D2D'}}>
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            style={{width: '100%', padding: '14px', background: '#1D9E75', color: 'white', border: 'none', borderRadius: '8px', fontSize: '15px', fontWeight: '500', cursor: loading ? 'not-allowed' : 'pointer', transition: 'background 0.2s', opacity: loading ? 0.7 : 1}}
            onMouseEnter={(e) => !loading && (e.target.style.background = '#0F6E56')}
            onMouseLeave={(e) => e.target.style.background = '#1D9E75'}
          >
            {loading ? 'Connexion...' : 'Se connecter'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
